//wtf verwijder dit
export enum TABLE_TEMPLATE {
  DEFAULT = "xxx",
}
